import { Native } from '@givebacks/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ConsumerBackerResponse } from '../../../backer/consumer/backer/backer.types';
import { useShowConsumerBacker } from '../../../backer/consumer/backer/get';
import { backerKeys } from '../../../backer/query-key-factory';
import usePollingUpdater from '../../../utils/usePollingUpdater';
import { useCoreApi } from '../../api';
import { coreKeys } from '../../query-key-factory';

const useDeleteUserCauseSelection = () => {
  const CoreApi = useCoreApi();
  const queryClient = useQueryClient();
  const { pollQuery } = usePollingUpdater({
    useQuery: useShowConsumerBacker,
    selector: (data) => Boolean((data as ConsumerBackerResponse)?.backer?.student_fees_access),
    onDataUpdated: () => {
      Native.postAction('invalidate_query_key', { queryKey: backerKeys.consumer.backer.all });
    },
  });
  const deleteCauseSelection = async ({ causeId }: { causeId: string }) => {
    const { data } = await CoreApi.delete(`/cause_selections/${causeId}`);
    return data;
  };

  return useMutation({
    mutationFn: deleteCauseSelection,
    onSuccess() {
      void queryClient.invalidateQueries({ queryKey: coreKeys.user.causeSelection.all });
    },
    onSettled: () => {
      const initialData: ConsumerBackerResponse | undefined = queryClient.getQueryData(
        backerKeys.consumer.backer.detail
      );

      // only poll if they have access to student fees
      if (initialData?.backer.student_fees_access) {
        void pollQuery({ initialData: initialData });
      }
    },
  });
};
export { useDeleteUserCauseSelection };
